<template>
    <div class="nc-history-contacts">

        <div class="nc-history-contacts__filters">
            <v-custom-input
                v-model="search"
                class="size_small"
                icon="#icon-search"
                placeholder="Введите номер телефона"
                autocomplete="off"
            />
            <v-custom-select
                v-if="categories.length"
                v-model="categoryId"
                class="nc-history-contacts__select"
                :list="categories"
                placeholder="Все категории"
            />
            <div class="nc-history-contacts__dates">
                <v-custom-input
                    v-model="dateFrom"
                    class="size_small nc-history-contacts__date-input"
                    type="date"
                    :buttonIcon="dateFrom ? '#icon-close' : ''"
                    :iconSize="{ w: 10, h: 10 }"
                    @buttonClick="dateFrom = ''"
                />
                <span class="nc-history-contacts__dates-sep">—</span>
                <v-custom-input
                    v-model="dateTo"
                    class="size_small nc-history-contacts__date-input"
                    type="date"
                    :buttonIcon="dateTo ? '#icon-close' : ''"
                    :iconSize="{ w: 10, h: 10 }"
                    @buttonClick="dateTo = ''"
                />
            </div>
        </div>

        <v-preloader v-if="isLoading" class="preloader_type_button" size="small" />

        <template v-else>
            <div ref="list" class="new-chat-list">
                <template v-if="list.length">
                    <new-chat-history-contact-item
                        v-for="item in list"
                        :key="item.id"
                        :item="item"
                        @click="$emit('select', $event)"
                    />
                    <div v-if="isLoadingMore" class="nc-history-contacts__load-more">
                        <v-preloader class="preloader_type_button" size="small" />
                    </div>
                </template>
                <div v-else-if="searched" class="new-chat-list__empty">Ничего не найдено</div>
                <div v-else class="new-chat-list__empty">Загрузка...</div>
            </div>
        </template>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@api'
import NewChatHistoryContactItem from './NewChatHistoryContactItem.vue'
import vPreloader from '../../global/Preloader.vue'
import vCustomInput from '@components/global/CustomInput'
import vCustomSelect from '../../global/CustomSelect.vue'

export default {
    name: 'NewChatHistoryContacts',
    components: { NewChatHistoryContactItem, vPreloader, vCustomInput, vCustomSelect },
    data() {
        return {
            search:        '',
            dateFrom:      '',
            dateTo:        '',
            categoryId:    '',
            list:          [],
            isLoading:     false,
            isLoadingMore: false,
            searched:      false,
            searchTimer:   null,
            currentPage:   1,
            hasMore:       true,
        }
    },
    computed: {
        ...mapGetters('newChat', ['reference', 'historySearchPrefill']),
        categories() {
            return (this.reference && this.reference.categories_list) ? this.reference.categories_list : []
        },
    },
    created() {
        this._scrollHandler = () => this._onScroll()
        this._loadingMore   = false
        this._skipSearchWatch = false
    },
    mounted() {
        const prefill = this.historySearchPrefill
        if (prefill) {
            this._skipSearchWatch = true
            this.search = prefill
            this.$store.dispatch('newChat/setHistorySearchPrefill', '')
        }
        this.fetchHistory()
    },
    beforeDestroy() {
        const el = this.$refs.list
        if (el) el.removeEventListener('scroll', this._scrollHandler)
    },
    watch: {
        search() {
            if (this._skipSearchWatch) {
                this._skipSearchWatch = false
                return
            }
            clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(() => this.fetchHistory(), 500)
        },
        dateFrom()   { this.fetchHistory() },
        dateTo()     { this.fetchHistory() },
        categoryId() { this.fetchHistory() },
        isLoading(val) {
            if (!val) this.$nextTick(() => this._attachScrollListener())
        },
    },
    methods: {
        _buildParams() {
            const params = {}
            if (this.search)     params.search      = this.search
            if (this.dateFrom)   params.date_from   = this.dateFrom
            if (this.dateTo)     params.date_to     = this.dateTo
            if (this.categoryId) params.category_id = this.categoryId
            return params
        },

        fetchHistory() {
            this.isLoading   = true
            this.currentPage = 1
            this.hasMore     = true

            api.newChat.getHistoryList({ ...this._buildParams(), page: 1 })
                .then(response => {
                    const items = Array.isArray(response) ? response : (response.items || [])
                    const limit = (response.pagination && response.pagination.limit) || 50
                    this.list     = items
                    this.searched = true
                    if (items.length < limit) this.hasMore = false
                })
                .catch(err => {
                    console.error('[NewChat] history error:', err)
                    this.list = []
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        _attachScrollListener() {
            const el = this.$refs.list
            if (!el || el._hasScrollListener) return
            el.addEventListener('scroll', this._scrollHandler)
            el._hasScrollListener = true
        },

        _onScroll() {
            if (this._loadingMore || !this.hasMore) return
            const el = this.$refs.list
            if (!el) return
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
                this._loadMore()
            }
        },

        _loadMore() {
            const nextPage = this.currentPage + 1
            this._loadingMore  = true
            this.isLoadingMore = true

            api.newChat.getHistoryList({ ...this._buildParams(), page: nextPage })
                .then(response => {
                    const items = Array.isArray(response) ? response : (response.items || [])
                    const limit = (response.pagination && response.pagination.limit) || 50
                    const existingIds = new Set(this.list.map(i => i.id))
                    const newItems = items.filter(i => !existingIds.has(i.id))

                    if (newItems.length === 0) {
                        this.hasMore = false
                    } else {
                        this.list = [...this.list, ...newItems]
                        this.currentPage = nextPage
                        if (items.length < limit) this.hasMore = false
                    }
                })
                .catch(err => {
                    console.error('[NewChat] history loadMore error:', err)
                })
                .finally(() => {
                    this._loadingMore  = false
                    this.isLoadingMore = false
                })
        },
    },
}
</script>

<style lang="scss">
@import '../../../../../gulp-src/app/scss/_variables';

.nc-history-contacts {
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
    min-height: 0;

    &__filters {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    &__select {
        .custom-select__input {
            height: 32px;
            min-height: 32px;
        }
    }

    &__dates {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    &__dates-sep {
        flex: 0 0 auto;
        color: $global-gray;
        font-size: 13px;
    }

    &__date-input {
        flex: 1 1 0;
        min-width: 0;

        input[type="date"] {
            font-size: 13px;
            min-width: 0;
        }
    }

    &__load-more {
        display: flex;
        justify-content: center;
        padding: 8px 0;
    }
}
</style>